import { useShallow } from "zustand/react/shallow";

import type { ModalCloseSource } from "./modal-behavior";
import { ModalView } from "./modal-view";
import { useRouteModalsStore } from "./route-modals.store";

interface RouteModalViewProps {
  depth: number;
  onContentResize: () => void;
  onStateChange: (value: unknown) => void;
  onClose: (source: ModalCloseSource) => void;
}

export const RouteModalView = (props: RouteModalViewProps) => {
  const children = useRouteModalsStore(useShallow((state) => state.children));
  const hasCloseButton = useRouteModalsStore((state) => state.behaviorOptions?.hasCloseButton);
  const peekState = useRouteModalsStore(useShallow((state) => state.peekState));

  const setBehaviorOptions = useRouteModalsStore((state) => state.setBehaviorOptions);

  return (
    <ModalView
      {...props}
      hasCloseButton={hasCloseButton}
      onBehaviorChange={setBehaviorOptions}
      onPeekState={peekState}
      onStateChange={props.onStateChange}
      renderStackOverlay={null}
    >
      {children}
    </ModalView>
  );
};
